import styled from "styled-components";
import useMenuTitle from "../../../hooks/useMenuTitle";
import { useOrientation } from "../../../hooks/useOrienttation";
import { useEffect, useState } from "react";
import WeekMenuPreview from "../../lunchMenu/WeekMenuPreview";
import Dispatch from "../CraneFillgrade/Dispatch";
import HeadingSection from "../../maintenance/HeadingSection";
import { useSearchParams } from "react-router-dom";
import Machine from "./Machine";



const ParentContainer = styled.div`
  zoom: 1;
  @media (max-width: 1440px) {
    zoom: 0.8;
  }
  display: flex;
  flex-direction: column;
  height: ${({ $height }) => $height}px;
  overflow: hidden;
  gap: 1rem;
  box-sizing: border-box;
`;

const Section = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;

  &:first-child {
    flex: 2;
  }

  &:last-child {
    flex: 3;
  }
`;

const PortraitSection = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;

  & > div:nth-child(1) {
    flex: 1;
  }

  & > div:nth-child(2),
  & > div:nth-child(3) {
    flex: 3;
  }
`;

const TopGridContainer = styled.div`
  display: grid;
  grid-template-columns: 5fr 5fr 3fr;
  gap: 1rem;
  padding: 1rem;
  box-sizing: border-box;
  flex: 1;
  overflow: hidden;
`;

const PortraitTopGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
  padding: 1rem;
  flex: 1;
  box-sizing: border-box;
`;

const PortraitBottomGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
  padding: 1rem;
  flex: 1;
  box-sizing: border-box;
`;

/* ⬇️ Bottom now has 3 boxes; left spans two of the old widths via 2fr */
const BottomGridContainer = styled.div`
  display: grid;
  grid-template-columns: 5fr 5fr 3fr;
  grid-template-rows: 3fr 3fr 1fr;  
  grid-template-areas:
    "a b c"   
    "d e f"
    "g g f";
  gap: 1.4rem;
  padding: 0.1rem;
  padding-left: 1rem;  
  box-sizing: border-box;
  flex: 1;
  overflow: hidden;
`;



const RowContainer3 = styled.div`
  display: flex;
  width: 100%;
  height: 100%;  
  background-color: var(--backdrop-color);
  backdrop-filter: blur(10px);
  box-shadow: var(--shadow-div-md);
  border-radius: 1rem;
  overflow: hidden;
`;


const BoxMergedInner = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 1rem;
  box-shadow: var(--shadow-div-md);
  overflow: hidden;
`;
const BoxA = styled(RowContainer3)`grid-area: a;`;
const BoxB = styled(RowContainer3)`grid-area: b;`;
const BoxC = styled(RowContainer3)`grid-area: c;`;
const BoxD = styled(RowContainer3)`grid-area: d;`;
const BoxE = styled(RowContainer3)`grid-area: e;`;
const BoxF = styled(RowContainer3)`grid-area: f;`;

const BoxMerged = styled(RowContainer3)`grid-area: g;`;



function DispatchHistory() {
  useMenuTitle("Dispatch History");
  const [searchParams, setSearchParams] = useSearchParams();
  const orientation = useOrientation();
  const isPortrait = orientation === "portrait";

  // constants of the original artboard
  const VB_W = 7207.08;
  const VB_H = 3505.63;

  // total vertical crop as fraction (e.g. 0.20 = 20% total, 10% top + 10% bottom)
  const CROP_Y = 0.2;

  const yOffset = (VB_H * CROP_Y) / 2;
  const croppedHeight = VB_H * (1 - CROP_Y);
  const croppedViewBox = `0 ${yOffset} ${VB_W} ${croppedHeight}`;

  const PADDING_TOP_REM = 15;
  const REM_IN_PX = 7; // adjust if root font-size is different
  const paddingTopPx = PADDING_TOP_REM * REM_IN_PX;
  const [height, setHeight] = useState(window.innerHeight);

  useEffect(() => {
    const updateHeight = () => {
      const header = document.getElementById("app-header");
      const headerHeight = header?.offsetHeight + paddingTopPx ?? 0;
      setHeight(window.innerHeight - headerHeight);
    };

    updateHeight(); // run on mount
    window.addEventListener("resize", updateHeight);
    return () => window.removeEventListener("resize", updateHeight);
  }, [paddingTopPx]);  

    // Auto rotate every 2 minutes
useEffect(() => {
  // Ensure seq is set on mount if absent
  if (searchParams.get("seq") == null) {
    setSearchParams(prev => {
      prev.set("seq", "0");
      return prev;
    });
  }

  const interval = setInterval(() => {
    setSearchParams(prev => {
      const current = parseInt(prev.get("seq") ?? "0", 10);
      prev.set("seq", String(current <= 1 ? current + 1 : 0));
      return prev;
    });
  }, 120000); //120000 = 2 minutes

  return () => clearInterval(interval);
}, [setSearchParams, searchParams]); 

  return (
    <ParentContainer $height={height}>
      <HeadingSection text="DISPATCH CRANES HISTORY" />

      <Section>
        {/* <HeadingSection text="STATUS" /> */}
        {isPortrait ? (
          <PortraitTopGrid>
            <RowContainer3>{/* <StatusActiveFaults /> */}</RowContainer3>
            <RowContainer3>
              {/* Keep a single StatusMaintenance in portrait */}
              {/* <StatusMaintenance /> */}
            </RowContainer3>
          </PortraitTopGrid>
        ) : (
          <BottomGridContainer>
            <BoxA>
              <Machine machineId="092" machineKey="A" />
            </BoxA>
            <BoxB>
              <Machine machineId="093" machineKey="B" />
            </BoxB>
            <BoxC>
              <Dispatch height={400} />
            </BoxC>
            <BoxD>
              <Machine machineId="094" machineKey="D" />
            </BoxD>
            <BoxE>
              <Machine machineId="095" machineKey="E" />
            </BoxE>
            <BoxF>
              <WeekMenuPreview />
            </BoxF>
            <BoxMerged>
              <BoxMergedInner> Box Merged</BoxMergedInner>
            </BoxMerged>
          </BottomGridContainer>
        )}
      </Section>
    </ParentContainer>
  );
}

export default DispatchHistory;
